// Student Lesson API Service
import { API_CONFIG } from '../config/api';

class LessonAPI {
    constructor() {
        this.baseURL = `${API_CONFIG.BASE_URL}/student/lessons`;
    }

    // Get authentication headers
    getAuthHeaders() {
        const token = localStorage.getItem('accessToken');
        return {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        };
    }

    // Handle API responses
    async handleResponse(response) {
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.detail || `HTTP ${response.status}: ${response.statusText}`);
        }
        return response.json();
    }

    // Get published lessons for students
    async getPublishedLessons(params = {}) {
        try {
            const queryParams = new URLSearchParams();

            if (params.page) queryParams.append('page', params.page);
            if (params.limit) queryParams.append('limit', params.limit);
            if (params.gradeFilter) queryParams.append('grade_filter', params.gradeFilter);
            if (params.domainFilter) queryParams.append('domain_filter', params.domainFilter);
            if (params.search) queryParams.append('search', params.search);

            const url = `${this.baseURL}${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
            console.log('Fetching published lessons from:', url);

            const response = await fetch(url, {
                method: 'GET',
                headers: this.getAuthHeaders()
            });

            const data = await this.handleResponse(response);
            console.log('Published lessons fetched successfully:', data);
            return data;
        } catch (error) {
            console.error('Error fetching published lessons:', error);
            throw error;
        }
    }

    // Get a specific published lesson
    async getPublishedLesson(lessonId) {
        try {
            console.log('Fetching published lesson:', lessonId);

            const response = await fetch(`${this.baseURL}/${encodeURIComponent(lessonId)}`, {
                method: 'GET',
                headers: this.getAuthHeaders()
            });

            const data = await this.handleResponse(response);
            console.log('Published lesson fetched successfully:', data);
            return data;
        } catch (error) {
            console.error('Error fetching published lesson:', error);
            throw error;
        }
    }
}

// Create and export singleton instance
const lessonAPI = new LessonAPI();
export default lessonAPI;